import React, { FC } from 'react'

import { CheckInInstructionsStatus } from '@avantstay/arriere-clients/dist/arriereBackoffice'
import { CheckboxBasedFilter } from '@avantstay/backoffice-core'

import { FiltersSharedProps } from '@new/__global/components/Filters/Filters.types'
import { checkInInstructionsStatusFilterOptions } from '@new/__global/constants/filter'

interface CheckInInstructionsStatusFilterProps extends FiltersSharedProps {
  initialValue?: CheckInInstructionsStatus[]
  onChange: (value?: CheckInInstructionsStatus[]) => void
  shouldUpdateOnInitialValueChange?: boolean
  title: string
}

export const CheckInInstructionsStatusFilter: FC<CheckInInstructionsStatusFilterProps> = props => (
  <CheckboxBasedFilter options={checkInInstructionsStatusFilterOptions} {...props} />
)
